import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { query } from '@angular/animations';
import { ExpensesComponent } from '../expenses/expenses.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custody-settlement',
  templateUrl: './custody-settlement.component.html',
  styleUrls: ['./custody-settlement.component.css']
})
export class CustodySettlementComponent implements OnInit {

  addDialogRef: MatDialogRef<ExpensesComponent>;
  @ViewChild(MatSort) sort: MatSort;

  public menu_item_id = '50';

  employee_no: string;
  custody_acct = { 'acct_number': '', 'sub_acct_name': '' };
  acct_balance: string = '';

  // employee_no = "40002";
  // sub_acct_name: string;
  // custoday_list = [];

  search_obj = {
    'placeholder': 'رقم الموظف/ اسم الموظف', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`employee`', 'selected_no': 'employee_no',
      'field_list': ['employee_no', 'name', 'name_en']
    }]
  };

  Employee_Placeholder;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Employee_Placeholder').subscribe((res: string) => {
      this.Employee_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Employee_Placeholder;
  }

  ngOnInit() {
    //for testing
    // this.custoday();
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.employee_no = search_result['no'];
    this.custody_acct = { 'acct_number': '', 'sub_acct_name': '' };
    this.acct_balance = '';

    if (this.employee_no != '') {
      let query = "SELECT * FROM `sub_acct` WHERE `status` = '1' AND `main_acct_no` = '104' AND `emp_no` = '" +
        this.employee_no + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.data['list'].length > 0) {
            this.custody_acct = data.data['list']['0'];
            this.acct_balance = 1000;
          }
        });
    }
    // this.custoday();
  }



  // custoday() {
  //   let query = "SELECT * FROM `sub_acct` WHERE `status` = '1' AND `main_acct_no` = '104' AND `emp_no` = '" + this.employee_no + "'";
  //   let obj = { cmd: 'getList', query: query };
  //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //     .subscribe(data => {
  //       this.custoday_list = data.data['list'];
  //       if (this.custoday_list.length > 0)
  //         this.sub_acct_name = this.custoday_list['0']['sub_acct_name'];
  //     });
  // }

  settle() {
    let dialog_data = {
      'table_name': 'expenses',
      'exp_id': '0', 'exp_no': '',
      'invoice_no': '', 'invoice_date': '',
      'amount': '', 'exp_acct': '0',
      'exp_desc': '', 'paid_from': 'custody',
      'acct_number': this.custody_acct['acct_number'],
      'cost_center': '0', 'comment': ''
    };
    this.addDialogRef = this.dialog.open(ExpensesComponent, {
      hasBackdrop: false,
      data: dialog_data,
      width: "90%",
      height: "90%",
    });

    // if (this.custoday_list.length > 0) {
    // dialog_data
    // }
    // else
    //   alert("هذا الموظف لا يملك عهدة");
  }

}
